import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DomainManagementTableContainer from '../domain-management/domain-management-table-container';

import {
    domainGroupsSelector
} from '../../common/selectors/domain-groups-selectors';

import { openClaimedDomainDetailsPane } from '../../common/actions/right-pane-action-creators';

import {
    claimedParentDomainsTableDataSelector,
    claimedSubdomainsTableDataSelector,
    claimedSubdomainsOrgDomainsSelector,
} from './claimed-domains-selectors';
import {
    claimedDomainsWithCountsIsLoadingSelector,
    claimedTotalItemsSelector,
} from '../../common/selectors/claimed-domains-with-counts-selectors';
import { isActiveRightPaneSelector } from '../../common/selectors/right-pane-selectors';

import { formatMultiSelectData } from '../../utils/common-utils';

import {
    domainNameColumn,
    domainTypeColumn,
    dmarcStatusPolicyColumn,
    dmarcSubdomainPolicyColumn,
    totalVolumeColumn,
    domainGroupsColumn,
    lastPolicyChangeDateColumn,
    dateApprovedColumn
} from '../constants/column-definitions';

import { DOMAIN_HIERARCHY_SUBDOMAIN, DOMAIN_MANAGEMENT_TABLE_TYPE_CLAIMED } from '../../common/constants/definitions';

const buildColumnsDefs = ( selectedDomainFilter ) => {
    /* Table columns are determined by `field`, but we specify `colId` to use as the order_by query param on sort or as the filter query param */
    const baseColumnDefs = [
        domainNameColumn,
        domainTypeColumn,
        totalVolumeColumn,
        dmarcStatusPolicyColumn,
        dmarcSubdomainPolicyColumn,
        lastPolicyChangeDateColumn,
        dateApprovedColumn,
        domainGroupsColumn,
    ];

    if( selectedDomainFilter ===  DOMAIN_HIERARCHY_SUBDOMAIN ){
        // exclude the sp= column on the Subdomains table
        baseColumnDefs.splice( 4, 1 );
    }

    return baseColumnDefs;
};

export class ClaimedDomainsTableContainer extends Component{

    render(){

        const {
            claimedParentDomainsData, claimedSubdomainsData, claimedSubdomainsOrgDomains, domainGroups,
            isActiveTable, isLoading, openClaimedDomainDetailsPane, selectedDomainFilter, totalItemCount
        } = this.props;

        const columnDefs = buildColumnsDefs( selectedDomainFilter, domainGroups );

        const orgDomainSelectData = selectedDomainFilter === DOMAIN_HIERARCHY_SUBDOMAIN ?
            formatMultiSelectData( claimedSubdomainsOrgDomains ) : null;
        const data = selectedDomainFilter === DOMAIN_HIERARCHY_SUBDOMAIN ?
            claimedSubdomainsData : claimedParentDomainsData;

        return (
            <DomainManagementTableContainer
                columnDefs={columnDefs}
                data={data}
                domainGroups={ formatMultiSelectData( this.props.domainGroups ) }
                isActiveTable={isActiveTable}
                isLoading={isLoading}
                onRowClick={openClaimedDomainDetailsPane}
                orgDomainSelectData={orgDomainSelectData}
                selectedDomainFilter={selectedDomainFilter}
                totalItemCount={ totalItemCount}
                type={DOMAIN_MANAGEMENT_TABLE_TYPE_CLAIMED}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        claimedParentDomainsData: claimedParentDomainsTableDataSelector( state ),
        claimedSubdomainsData: claimedSubdomainsTableDataSelector( state ),
        claimedSubdomainsOrgDomains: claimedSubdomainsOrgDomainsSelector( state ),
        domainGroups: domainGroupsSelector( state ),
        isActiveTable: isActiveRightPaneSelector( state, 'claimedDomainDetails' ),
        isLoading: claimedDomainsWithCountsIsLoadingSelector( state ),
        totalItemCount: claimedTotalItemsSelector( state ),
    };
};

const mapDispatchToProps = {
    openClaimedDomainDetailsPane,
};

ClaimedDomainsTableContainer.propTypes = {
    claimedParentDomainsData: PropTypes.array.isRequired,
    claimedSubdomainsData: PropTypes.array.isRequired,
    claimedSubdomainsOrgDomains: PropTypes.array.isRequired,
    domainGroups: PropTypes.array.isRequired,
    isActiveTable: PropTypes.bool,
    isLoading: PropTypes.bool.isRequired,
    openClaimedDomainDetailsPane: PropTypes.func.isRequired,
    selectedDomainFilter: PropTypes.string,
    totalItemCount: PropTypes.number
};

export default connect( mapStateToProps, mapDispatchToProps )( ClaimedDomainsTableContainer );
